import { AutomationEventTypes } from "../AutomationModuleTypes";
import _ from "lodash";

const vt = {
    STRING: "string",
    NUMBER: "number",
    BOOLEAN: "boolean",
    DATE: "date",
    DATETIME: "datetime",
    TIME: "time",
    ENUM: "enum",
    ARRAY: "array",
    ARRAY_STRING: "array_string",
    OBJECT: "object",
};

const contexts = {
    EVENT: "event",
    SYSTEM: "system",
};

const ga = (
    context,
    value,
    label,
    valueType = "string",
    controlType = "input",
    subAttributes = [],
    defaultFilterValue = undefined,
    defaultOperator = undefined,
    availableOperators = undefined,
    options = undefined
) => {
    return {
        context,
        value,
        label,
        defaultOperator: defaultOperator || "equal",
        defaultFilterValue,
        availableOperators: availableOperators || ["equal", "not_equal"],
        controlType,
        options,
        subAttributes,
        valueType,
    };
};

class WebphoneModuleAttributeFactory {
    constructor(parent) {
        this.parent = parent;
    }

    generate() {
        return _.concat(
            this.callEvent(),
            this.callRinging(),
            this.callAnswered(),
            this.callEnded(),
            this.inboundCall(),
            this.outboundCall(),
            this.deviceStateChanged(),
            this.deviceRinging(),
            this.deviceInUse(),
            this.deviceAvailable()
        );
    }

    callEvent() {
        const e = AutomationEventTypes.WEBPHONE.CALL_EVENT;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Olay", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.uniqueid`, "Benzersiz ID", vt.STRING),
                ga(context, `${prefix}.event`, "Olay Türü", vt.STRING),
                ga(context, `${prefix}.calleridnum`, "Arayan Numara", vt.STRING),
                ga(context, `${prefix}.calleridname`, "Arayan İsim", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal", vt.STRING),
                ga(context, `${prefix}.context`, "Bağlam", vt.STRING),
                ga(context, `${prefix}.exten`, "Dahili", vt.STRING),
                ga(context, `${prefix}.privilege`, "Yetki", vt.STRING),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    callRinging() {
        const e = AutomationEventTypes.WEBPHONE.CALL_RINGING;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Çağrı Geliyor", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.uniqueid`, "Benzersiz ID", vt.STRING),
                ga(context, `${prefix}.calleridnum`, "Arayan Numara", vt.STRING),
                ga(context, `${prefix}.calleridname`, "Arayan İsim", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal", vt.STRING),
                ga(context, `${prefix}.context`, "Bağlam", vt.STRING),
                ga(context, `${prefix}.exten`, "Dahili", vt.STRING),
                ga(context, `${prefix}.connectedlinenum`, "Bağlanan Hat Numarası", vt.STRING),
                ga(context, `${prefix}.connectedlinename`, "Bağlanan Hat İsmi", vt.STRING),
                ga(context, `${prefix}.direction`, "Arama Yönü", vt.STRING, "select", [], undefined, undefined, undefined, [
                    { value: "inbound", label: "Gelen Arama" },
                    { value: "outbound", label: "Giden Arama" },
                ]),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    callAnswered() {
        const e = AutomationEventTypes.WEBPHONE.CALL_ANSWERED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Araması Cevaplandı", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.uniqueid`, "Benzersiz ID", vt.STRING),
                ga(context, `${prefix}.calleridnum`, "Arayan Numara", vt.STRING),
                ga(context, `${prefix}.calleridname`, "Arayan İsim", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal", vt.STRING),
                ga(context, `${prefix}.context`, "Bağlam", vt.STRING),
                ga(context, `${prefix}.exten`, "Dahili", vt.STRING),
                ga(context, `${prefix}.connectedlinenum`, "Bağlanan Hat Numarası", vt.STRING),
                ga(context, `${prefix}.connectedlinename`, "Bağlanan Hat İsmi", vt.STRING),
                ga(context, `${prefix}.direction`, "Arama Yönü", vt.STRING, "select", [], undefined, undefined, undefined, [
                    { value: "inbound", label: "Gelen Arama" },
                    { value: "outbound", label: "Giden Arama" },
                ]),
                ga(context, `${prefix}.answeredAt`, "Cevaplandığı Zaman", vt.DATETIME),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    callEnded() {
        const e = AutomationEventTypes.WEBPHONE.CALL_ENDED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Araması Sonlandı", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.uniqueid`, "Benzersiz ID", vt.STRING),
                ga(context, `${prefix}.calleridnum`, "Arayan Numara", vt.STRING),
                ga(context, `${prefix}.calleridname`, "Arayan İsim", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal", vt.STRING),
                ga(context, `${prefix}.context`, "Bağlam", vt.STRING),
                ga(context, `${prefix}.exten`, "Dahili", vt.STRING),
                ga(context, `${prefix}.connectedlinenum`, "Bağlanan Hat Numarası", vt.STRING),
                ga(context, `${prefix}.connectedlinename`, "Bağlanan Hat İsmi", vt.STRING),
                ga(context, `${prefix}.direction`, "Arama Yönü", vt.STRING, "select", [], undefined, undefined, undefined, [
                    { value: "inbound", label: "Gelen Arama" },
                    { value: "outbound", label: "Giden Arama" },
                ]),
                ga(context, `${prefix}.cause`, "Sonlandırma Sebebi", vt.STRING),
                ga(context, `${prefix}.causeTxt`, "Sonlandırma Sebebi Metni", vt.STRING),
                ga(context, `${prefix}.billsec`, "Faturalandırma Süresi", vt.NUMBER),
                ga(context, `${prefix}.duration`, "Arama Süresi", vt.NUMBER),
                ga(context, `${prefix}.disposition`, "Arama Durumu", vt.STRING, "select", [], undefined, undefined, undefined, [
                    { value: "ANSWERED", label: "Cevaplandı" },
                    { value: "NO ANSWER", label: "Cevapsız" },
                    { value: "BUSY", label: "Meşgul" },
                    { value: "FAILED", label: "Başarısız" },
                ]),
                ga(context, `${prefix}.endedAt`, "Sonlandığı Zaman", vt.DATETIME),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
                ga(context, `${prefix}.recordingfile`, "Kayıt Dosyası", vt.STRING),
                ga(context, `${prefix}.recordurl`, "Kayıt URL'i", vt.STRING),
            ]),
        ];
    }

    inboundCall() {
        const e = AutomationEventTypes.WEBPHONE.INBOUND_CALL;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Gelen Webphone Araması", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.uniqueid`, "Benzersiz ID", vt.STRING),
                ga(context, `${prefix}.calleridnum`, "Arayan Numara", vt.STRING),
                ga(context, `${prefix}.calleridname`, "Arayan İsim", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal", vt.STRING),
                ga(context, `${prefix}.context`, "Bağlam", vt.STRING),
                ga(context, `${prefix}.exten`, "Dahili", vt.STRING),
                ga(context, `${prefix}.dnid`, "DNID", vt.STRING),
                ga(context, `${prefix}.rdnis`, "RDNIS", vt.STRING),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    outboundCall() {
        const e = AutomationEventTypes.WEBPHONE.OUTBOUND_CALL;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Giden Webphone Araması", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.uniqueid`, "Benzersiz ID", vt.STRING),
                ga(context, `${prefix}.calleridnum`, "Arayan Numara", vt.STRING),
                ga(context, `${prefix}.calleridname`, "Arayan İsim", vt.STRING),
                ga(context, `${prefix}.channel`, "Kanal", vt.STRING),
                ga(context, `${prefix}.context`, "Bağlam", vt.STRING),
                ga(context, `${prefix}.exten`, "Dahili", vt.STRING),
                ga(context, `${prefix}.destinationContext`, "Hedef Bağlam", vt.STRING),
                ga(context, `${prefix}.destinationExten`, "Hedef Dahili", vt.STRING),
                ga(context, `${prefix}.destinationChannel`, "Hedef Kanal", vt.STRING),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    deviceStateChanged() {
        const e = AutomationEventTypes.WEBPHONE.DEVICE_STATE_CHANGED;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Cihaz Durumu Değişti", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.device`, "Cihaz", vt.STRING),
                ga(context, `${prefix}.state`, "Yeni Durum", vt.STRING, "select", [], undefined, undefined, undefined, [
                    { value: "UNKNOWN", label: "Bilinmeyen" },
                    { value: "NOT_INUSE", label: "Kullanımda Değil" },
                    { value: "INUSE", label: "Kullanımda" },
                    { value: "BUSY", label: "Meşgul" },
                    { value: "INVALID", label: "Geçersiz" },
                    { value: "UNAVAILABLE", label: "Kullanılamaz" },
                    { value: "RINGING", label: "Çalıyor" },
                    { value: "RINGINUSE", label: "Çalıyor (Kullanımda)" },
                    { value: "ONHOLD", label: "Beklemede" },
                ]),
                ga(context, `${prefix}.oldState`, "Eski Durum", vt.STRING),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    deviceRinging() {
        const e = AutomationEventTypes.WEBPHONE.DEVICE_RINGING;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Cihaz Çalıyor", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.device`, "Cihaz", vt.STRING),
                ga(context, `${prefix}.state`, "Durum", vt.STRING),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    deviceInUse() {
        const e = AutomationEventTypes.WEBPHONE.DEVICE_IN_USE;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Cihaz Kullanımda", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.device`, "Cihaz", vt.STRING),
                ga(context, `${prefix}.state`, "Durum", vt.STRING),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }

    deviceAvailable() {
        const e = AutomationEventTypes.WEBPHONE.DEVICE_AVAILABLE;
        const context = contexts.EVENT;
        const prefix = `event.${e}`;

        return [
            ga(context, prefix, "Webphone Cihaz Müsait", vt.OBJECT, undefined, [
                ga(context, `${prefix}.$..*`, "*", vt.OBJECT),
                ga(context, `${prefix}.siteId`, "Site ID", vt.STRING),
                ga(context, `${prefix}.channelId`, "Kanal ID", vt.STRING),
                ga(context, `${prefix}.device`, "Cihaz", vt.STRING),
                ga(context, `${prefix}.state`, "Durum", vt.STRING),
                ga(context, `${prefix}.timestamp`, "Zaman Damgası", vt.NUMBER),
                ga(context, `${prefix}.createdAt`, "Oluşturulma Tarihi", vt.DATETIME),
            ]),
        ];
    }
}

export default WebphoneModuleAttributeFactory; 